import React, { useEffect, useRef, useState } from "react";

const MovingStrip = ({ config }) => {
  const { src, speed = 2 } = config;
  const [scrollDirection, setScrollDirection] = useState(0); // -1 (esquerda), 1 (direita), 0 (parado)
  const positionRef = useRef(0);
  const animationRef = useRef(null);
  const stripRef = useRef(null);

  useEffect(() => {
    const pageElement = document.getElementById("page");
    if (!pageElement) return;

    let lastScrollY = pageElement.scrollTop;
    let isScrolling;

    const handleScroll = () => {
      const currentScrollY = pageElement.scrollTop;
      const direction = currentScrollY > lastScrollY ? 1 : -1;
      setScrollDirection(direction);
      lastScrollY = currentScrollY;

      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        setScrollDirection(0); // Para o movimento quando o usuário para de rolar
      }, 100);
    };

    pageElement.addEventListener("scroll", handleScroll);
    return () => pageElement.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const moveStrip = () => {
      if (scrollDirection !== 0 && stripRef.current) {
        positionRef.current += scrollDirection * speed;
        stripRef.current.style.transform = `translateX(${positionRef.current}px)`;

        const firstImgWidth = stripRef.current.firstChild.clientWidth;
        const totalWidth = stripRef.current.scrollWidth / 2; // Metade da largura total (porque duplicamos a lista)

        // Quando ultrapassa metade da lista, reseta para o início suave
        if (positionRef.current <= -totalWidth) {
          positionRef.current += totalWidth;
        } else if (positionRef.current >= 0) {
          positionRef.current -= totalWidth;
        }
      }
      animationRef.current = requestAnimationFrame(moveStrip);
    };

    animationRef.current = requestAnimationFrame(moveStrip);
    return () => cancelAnimationFrame(animationRef.current);
  }, [scrollDirection, speed]);

  return (
    <div
      className="moving-strip"
      style={{
        backgroundColor: `var(--color-${config.color || "dark"})`,
      }}
    >
      <div className="moving-strip-content" ref={stripRef}>
        {/* Duas cópias da lista para criar o efeito de loop perfeito */}
        {[...Array(2)].map((_, i) => (
          <div key={i} className="moving-strip-duplicate">
            {[...Array(10)].map((_, index) => (
              <img
                key={index}
                src={src}
                alt="strip-img"
                className="strip-img"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MovingStrip;
